import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { AddressLine1Autocomplete } from '../AddressLine1Autocomplete';
import { FloatingLabelInput } from '../FloatingLabelInput';
import { FloatingLabelSelect } from '../FloatingLabelSelect';
import { filterProps, safeNormalize } from '../../../utils';
import { isStateFieldInput, prefixString, shouldValidateAddressField } from './utils';
import { validateAddress } from './validations';
var COMPONENTS_MAP = {
  city: FloatingLabelInput,
  line1: FloatingLabelInput,
  line2: FloatingLabelInput,
  postalCode: FloatingLabelInput,
  postcode: FloatingLabelInput,
  state: FloatingLabelSelect
};
var PROPS_TO_FILTER = ['addressSelectionHandler', 'contentObject', 'disallowUnsupportedCharacters', 'enableAddressAutocomplete', 'fieldsPrefix', 'id', 'isRequired', 'maxLength', 'name', 'regex', 'resetHandler', 'suggestedAddressList', 'componentsMapOverrides', 'enableAddressAutocompleteSingleLine', 'enableDontSeeMyAddressSuggestion', 'isMobile', 'overrideAddressSuggestionStyle'];

var AddressInputNotMemoized = props => {
  var {
    fieldsPrefix,
    id,
    isRequired,
    name,
    regex,
    componentsMapOverrides = {},
    enableAddressAutocompleteSingleLine,
    enableDontSeeMyAddressSuggestion,
    isMobile,
    overrideAddressSuggestionStyle
  } = props;
  var filteredProps = filterProps(props, PROPS_TO_FILTER);
  var additionalProps = {};

  var fieldsMap = _objectSpread(_objectSpread({}, COMPONENTS_MAP), componentsMapOverrides);

  var Component = fieldsMap[name] || FloatingLabelInput;
  var isStateInput = isStateFieldInput(name, props.selectOptions);

  if (name === 'line1' && props.enableAddressAutocomplete) {
    Component = AddressLine1Autocomplete;
    additionalProps = {
      addressSelectionHandler: props.addressSelectionHandler,
      contentObject: props.contentObject,
      enableAddressAutocompleteSingleLine,
      enableDontSeeMyAddressSuggestion,
      fieldsPrefix,
      isMobile,
      overrideAddressSuggestionStyle,
      resetHandler: props.resetHandler,
      suggestedAddressList: props.suggestedAddressList,
      suppressBrowserAutofill: props.suppressBrowserAutofill
    };
  }

  if (name !== 'line1' && props.enableAddressAutocomplete && props.enableAddressAutocompleteSingleLine) {
    return null;
  }

  if (isStateInput) {
    Component = FloatingLabelInput;
  }

  var isState = name === 'state';
  var pattern = isState ? null : {
    flags: 'i',
    pattern: regex
  };
  var maxLength = isState ? null : props.maxLength;
  var isPostalCode = ['postcode', 'postalCode'].includes(name);
  var preprocessFn = isPostalCode ? safeNormalize : null;
  return React.createElement(Component, _extends({
    id: prefixString(id || name, fieldsPrefix),
    maxLength: maxLength,
    name: prefixString(name || id, fieldsPrefix),
    pattern: pattern,
    preprocessFn: preprocessFn,
    required: isRequired
  }, shouldValidateAddressField(name, props.selectOptions, props.disallowUnsupportedCharacters) ? {
    validationFn: validateAddress
  } : {}, additionalProps, filteredProps));
};

AddressInputNotMemoized.defaultProps = {
  enableAddressAutocompleteSingleLine: false,
  enableDontSeeMyAddressSuggestion: false,
  overrideAddressSuggestionStyle: false
};
var AddressInput = React.memo ? React.memo(AddressInputNotMemoized) : AddressInputNotMemoized;
export { AddressInput };